// extracted by mini-css-extract-plugin
export default {"loading":"styles_loading__mz6iI","loading-main-text":"styles_loading-main-text__QO8vG","loading-dots":"styles_loading-dots__-vnAk"};